import { useEffect, useRef, useState } from "react";
import {
    PaymentElement,
    useStripe,
    useElements
} from "@stripe/react-stripe-js";
import { useNavigate } from "react-router-dom";
import { Accordion, AccordionDetails, AccordionSummary, FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { PaymentAPI } from "../../api/PaymentAPI";
import { rootAction } from "../../redux/reducer/rootReducer";
import styles from '../../styles/modules/EventCheckout.module.css';
import { PaymentIcon } from "react-svg-credit-card-payment-icons/dist";
import CustomSwitch from "../CustomComponents/CustomSwitch/CustomSwitch";

function CheckoutDetails({ defaultCard, setIsLoading, isLoading, priceDetails, isCheckoutEnable, paymentIntentId, reservationFor }) {
    const userInfo = useSelector((store) => store.user.userInfo);
    const selectedClub = useSelector((store) => store.user.selectedClub);
    const { disablePayBtn, isTimerActive, isPaymentDoneForReservation } = useSelector((store) => store.root);
    const stripe = useStripe();
    const elements = useElements();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isSaveCard, setIsSaveCard] = useState(false);
    const [isAgree, setIsAgree] = useState(false);
    const [checkCard, setCheckCard] = useState(false);
    const [name, setName] = useState('');
    const [error, setError] = useState(false);
    const isFirstRender = useRef(true);
    const [paymentMethod, setPaymentMethod] = useState('');


    useEffect(() => {

        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (!isTimerActive && paymentIntentId && isPaymentDoneForReservation?.type !== 'payment') {
            cancelPaymentIntent();
        }

    }, [isTimerActive])

    const finishReservationPayment = () => {
        if (selectedClub?.calendarType === 'RESERVATION_CALENDAR') {
            dispatch(rootAction.setReservationPaymentStatus({ status: true, type: 'payment' }));
            navigate("/");
            return;
        }
        if (isCheckoutEnable && selectedClub?.isPlanRequired) {
            setTimeout(() => {
                dispatch(rootAction.setIsUpdateTotalSchedule(true));
                navigate("/");
            }, 1000);
        }
    }

    const handleCheckCard = () => {
        setCheckCard(!checkCard);
    }
  
    const cancelPaymentIntent = async () => {
        try {
            const reqData = {
                paymentIntentId,
                userId: reservationFor,
                clubId: selectedClub?.clubId
            }

            await PaymentAPI.postCancelPaymentIntent(reqData);
            dispatch(rootAction.setPaymentIntentId(null));
            navigate('/')
        } catch (error) {

        }
    }
    const handleMakePaymentMethod = async () => {
        if (!isAgree) {
            dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'warning', content: 'Please agree the terms and conditions.' }));
            return;
        }
        setIsLoading(true);
        try {
            const paymentDetails = {
                userId: reservationFor || userInfo.userId,
                clubId: selectedClub?.clubId,
                paymentIntentId: paymentIntentId,
                paymentMethodId: defaultCard?.paymentMethodId
            }
            const response = await PaymentAPI.postMakePaymentWithDefaultCard(paymentDetails);
            dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'success', content: "The payment was successful." }));
            finishReservationPayment();
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            console.error('Error in make payment:', error);
        }
    };
    const removePaymentMethod = async (id) => {
        await PaymentAPI.postRemovePaymentMethod({ paymentMethodId: id, userId: reservationFor, clubId: selectedClub?.clubId });
    }
    const handleSubmit = async (e) => {
        if (!name || name?.trim() === '') {
            setError(true);
        }
        if (!stripe || !elements || !name) {
            return;
        }

        if (!isAgree) {
            dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'warning', content: 'Please agree the terms and conditions.' }));
            return;
        }

        setIsLoading(true);

        const { error, paymentIntent } = await stripe.confirmPayment({
            elements,
            redirect: "if_required",
            confirmParams: {
                return_url: "",
                payment_method_data: {
                    billing_details: {
                        name: name,
                    },
                },
            },

        });

        if (paymentIntent === undefined) {
            setIsLoading(false);
            return;
        }
 
        
        
        if (paymentIntent?.status === "succeeded") {
            dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'success', content: "The payment was successful." }));
            if (!isSaveCard) {
                removePaymentMethod(paymentIntent?.payment_method);
            }
            setIsLoading(false);
            finishReservationPayment();
        }
        if (paymentIntent.status === "processing") {
            dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'success', content: "Please wait while the payment is processed." }));
            setIsLoading(false);
            if (!isSaveCard) {
                removePaymentMethod(paymentIntent?.payment_method);
            }
            finishReservationPayment();
        }
        if (error != undefined) {
            setIsLoading(false);
            if (error.type === "card_error" || error.type === "validation_error") {
                dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'error', content: error.message }))
            } else {
                dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'error', content: "An unexpected error occurred." }));
            }
        }
    };



    return (
        <div className={styles['season_checkout_container']}>
            <div className={styles['payment_method_container']}>
                <h2>Payment Method</h2>
                <div className={styles['payment_method_list']}>

                    <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="female"
                        name="radio-buttons-group"
                        value={paymentMethod}
                        onChange={(event) => event.target.value !== 'default_card' && setPaymentMethod(event.target.value)}
                    >
                        <Accordion
                            elevation={0}
                            sx={{
                                borderRadius: '10px',
                                '&::before': {
                                    display: 'none',
                                },
                                '&:last-of-type': {
                                    borderRadius: '10px',
                                },
                                '&:first-of-type': {
                                    borderRadius: '10px',
                                },
                                boxShadow: "rgba(0, 0, 0, 0.16) 0px 10px 36px 0px,rgba(0, 0, 0, 0.06) 0px 0px 0px 1px",
                                border: paymentMethod === 'credit_card' ? '2px solid var(--hoverColorBold)' : 'none'
                            }}
                            expanded={paymentMethod === 'credit_card'}
                        >
                            <AccordionSummary>
                                <Typography component="span">
                                    <FormControlLabel value="credit_card" control={<Radio sx={{
                                        color: "#8fbd04",
                                        '&.Mui-checked': {
                                            color: "#8fbd04",
                                        }
                                    }} />} label="Credit Card" />
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <form className={styles['card_input_form']}>
                                    {defaultCard?.last4Digits &&
                                        <>
                                            <h3>Use Default Card</h3>
                                            <div onClick={handleCheckCard} className={checkCard ? `${styles['default_card_body']} ${styles['active']}` : styles['default_card_body']}>
                                                <FormControlLabel value="default_card" control={<Radio checked={checkCard} sx={{
                                                    '&.Mui-checked': {
                                                        color: "rgb(255, 136, 0)",
                                                    },
                                                    padding: 0
                                                }} />} />
                                                <div className={styles['default_card_inner_body']}>
                                                    <div className={styles['card_number']}>
                                                        <h3>XXXX XXXX XXXX {defaultCard?.last4Digits}</h3>
                                                        <PaymentIcon format="flatRounded" type={defaultCard?.cardBrand} />
                                                    </div>
                                                    <div className={styles['card_exp']}>
                                                        <h3>Expire on</h3>
                                                        <p>{`${String(defaultCard?.expMonth)?.padStart(2, '0')}/${defaultCard?.expYear}`}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </>}
                                    {!checkCard &&
                                        <>
                                            <br />
                                            <hr />
                                            <h3>Enter New Card</h3>
                                            <PaymentElement id="payment-element" />

                                            <div className="payment_card_holder_name">
                                                <label htmlFor="cardHolderName"
                                                    className={error ? "payment_card_holder_name_label error" : "payment_card_holder_name_label"}>Card holder name</label>

                                                <input className={error ? "payment_card_holder_name_input error" : "payment_card_holder_name_input"} onChange={(e) => setName(e.target.value)} type="text" id="cardHolderName" />
                                            </div>

                                            <div className={styles['card_save_concent']}>
                                                <CustomSwitch checked={isSaveCard} onChange={(e) => setIsSaveCard(e.target.checked)} />
                                                <p>Would you like to keep this card for later use?</p>
                                            </div>
                                        </>}
                                </form>
                            </AccordionDetails>
                        </Accordion>

                    </RadioGroup>

                </div>
            </div>
            <div className={styles['price_container']}>
                <div className={styles['payment_summary_con']}>
                    <h3>Payment Summary</h3>
                    <div className={styles['payment_summary_details']}>
                        <p>{priceDetails?.totalHour > 1 ? 'Total Reservations' : 'Total Reservation'}</p>
                        <h4>{priceDetails?.totalReservations}</h4>
                    </div>
                    <div className={styles['payment_summary_details']}>
                        <p>{priceDetails?.totalHour > 1 ? 'Total Hours' : 'Total Hour'}</p>
                        <h4>{priceDetails?.totalHour}</h4>
                    </div>
                    {priceDetails?.processingFee != 0 &&
                     <div className={styles['payment_summary_details']}>
                        <p>Processing Fee</p>
                        <h4>${priceDetails?.processingFee}</h4>
                    </div>}
                    <hr />
                    <div className={styles['payment_summary_total']}>
                        <h3>Total Amount</h3>
                        <h3>${Number.isFinite(Number(priceDetails?.totalAmount)) ? Number(priceDetails.totalAmount).toFixed(2) : "0.00"}</h3>
                    </div>
                </div>
                <div className={styles['payment_concent']}>
                    <CustomSwitch checked={isAgree} onChange={(e) => setIsAgree(e.target.checked)} />
                    <p>By enabling this, I agree to the {selectedClub?.clubName} Terms and Policies.</p>
                </div>
                <div className={styles['pay_btn']}>
                    {checkCard
                        ? <button onClick={handleMakePaymentMethod} disabled={isLoading || !stripe || !elements} >
                            <p>Pay Using</p>
                            <PaymentIcon format="flatRounded" type={defaultCard?.cardBrand} />
                            <p> - {defaultCard.last4Digits}</p>
                        </button>
                        :
                        <button onClick={handleSubmit} disabled={isLoading || !stripe || !elements || paymentMethod === ''}>Pay now</button>}
                </div>
            </div>
        </div >
    );
}

export default CheckoutDetails